import React, { useState } from "react";

import styles from "./MeetTheTeamComponent.module.css";

const LongText = ({content, limit}) => {
  const [showAll, setShowAll] = useState(false);

  if (content.length <= limit) {
    // there is nothing more to show
    return <p className={styles.band_review_text}>{content}</p>;
  }
  if (showAll) {
    // We show the extended text and a link to reduce it
    return (
      <p className={styles.band_review_text}>
        {content}
        <a className={styles.band_review_text_white} onClick={() => setShowAll(false)}>
          Read less
        </a>
      </p>
    );
  }
  // In the final case, we show a text with ellipsis and a `Read more` button
  const toShow = content.substring(0, limit) + "...";
  return (
    <p className={styles.band_review_text}>
      {toShow}
      <a className={styles.band_review_text_white} onClick={() => setShowAll(true)}>
        Read more
      </a>
    </p>
  );
};

export default LongText;
